import { colors } from '../../Colors/colors'

export const sidebarTheme = {
   light: {
      baseSideBar: {
         backgroundColor: 'bg-base-white',
         borderColor: 'border-gray-200',
         dividerColor: 'border-blue-gray-700'
      },
      sbHeadingItem: {
         backgroundColor: 'bg-base-white',
         hoverBackgroundColor: 'hover:bg-gray-50',
         color: 'text-gray-400',
         outlineDotsHorizontalIcon: {
            color: colors['gray-500'],
            backgroundColor: 'bg-transparent',
            hoverBackgroundColor: 'hover:bg-gray-200'
         },
         plusIcon: {
            color: colors['gray-500'],
            backgroundColor: 'bg-transparent',
            hoverBackgroundColor: 'hover:bg-gray-200'
         },
         borderColor: 'border-gray-300'
      },
      sbCollapsibleItem: {
         bgColor: 'bg-base-white',
         selectedBGColor: 'bg-primary-50',
         selectedHoverBGColor: 'hover:bg-primary-50',
         hoverBGColor: 'hover:bg-gray-50',
         dragBGColor: `bg-gray-200`,
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-700',
         borderColor: 'border-gray-300',
         focusBorderColor: 'focus:border-primary-300',
         iconHoverColor: 'hover:bg-gray-200',
         plusIcon: {
            color: colors['gray-500']
         },
         collapsibleIcon: {
            color: colors['gray-500']
         },
         dividerColor: 'border-gray-300'
      },
      sbDefaultItem: {
         bgColor: 'bg-base-white',
         hoverBGColor: 'hover:bg-gray-50',
         textColor: 'text-gray-700',
         selectedBGColor: 'bg-primary-50',
         selectedHoverBGColor: 'bg-primary-50',
         selectedTextColor: 'text-primary-600',
         iconHoverColor: 'hover:bg-gray-200'
      },
      sbNavigationItem: {
         bgColor: 'bg-base-white',
         hoverBGColor: 'hover:bg-gray-50',
         textColor: 'text-gray-700',
         selectedBGColor: 'hover:bg-primary-50',
         selectedHoverBGColor: 'bg-primary-50',
         selectedTextColor: 'text-primary-600'
      },
      sidebarAction: {
         actionItemHoverColor: 'hover:bg-gray-50',
         deleteTextColor: 'text-error-600',
         actionItemTextColor: 'text-gray-900',
         dividerColor: 'border-gray-200'
      },
      sidebarFooter: {
         iconColor: colors['gray-500'],
         dividerColor: 'border-gray-200'
      },
      salesPipelinePickerTheme: {
         salesPipelineColor: 'text-gray-700',
         salesPipelineInputBgColor: 'bg-gray-25 hover:bg-gray-50',
         tickIconColor: colors['primary-600'],
         selectedSalesPipelineBgColor: 'bg-gray-50',
         customOptionHoverBgColor: ' hover:bg-gray-50',
         disabledSalesPipelineColor: 'text-gray-300'
      },
      salesTemplatePickerTheme: {
         salesTemplateColor: 'text-gray-700',
         salesTemplateInputBgColor: 'bg-gray-25 hover:bg-gray-50',
         tickIconColor: colors['primary-600'],
         selectedSalesTemplateBgColor: 'bg-gray-50',
         customOptionHoverBgColor: ' hover:bg-gray-50',
         disabledSalesTemplateColor: 'text-gray-300'
      }
   },
   dark: {}
}
